import { showElement, hideElement, isLoggedIn } from "./helper";

export function unlockArticles() {
    if (isLoggedIn()) {
        const user = IwwUserdata.USERDATA;
        // In Artikeldetail Elemente ein- bzw. ausblenden
        showElement(user.infodienste.map((element) => "open_article_" + element));
        hideElement(user.infodienste.map((element) => "closed_article_" + element));

        showElement(user.infodienste.map((element) => "open_download_" + element));
        hideElement(user.infodienste.map((element) => "closed_download_" + element));

        showElement(user.infodienste.map((element) => "share_article_open_" + element));
        hideElement(user.infodienste.map((element) => "share_article_closed_" + element));

        // Artikelteaser holen
        hideElement(user.infodienste.map((element) => "closed_artikel_teaser_" + element));

        for (let i = 0; i < user.infodienste.length; i++) {
            // Schloss bei Artikeln ausblenden wenn Abo vorhanden
            let string = "closed_artikel_teaser_" + user.infodienste[i];

            const closed_artikel_teaser = document.querySelectorAll('[id^="' + string + '"]');

            for (let i = 0; i < closed_artikel_teaser.length; i++) {
                closed_artikel_teaser[i].style.display = 'none';
            }

            // Schloss bei Downloads ausblenden wenn Abo vorhanden
            let string_download = "closed_download_teaser_" + user.infodienste[i];

            const closed_download_teaser = document.querySelectorAll('[id^="' + string_download + '"]');

            for (let i = 0; i < closed_download_teaser.length; i++) {
                closed_download_teaser[i].style.display = 'none';
            }

            // Bezeichnung "Leseprobe" bei Abo ausblenden bei Downloads ausblenden
            let id_sample_element = "sample_article_teaser_" + user.infodienste[i];

            const sample_elements = document.querySelectorAll('[id^="' + id_sample_element + '"]');
            for (let i = 0; i < sample_elements.length; i++) {
                sample_elements[i].style.display = 'none';
            }
        }
    }
}






